"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var BoxesModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxesModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const form_2 = require("../_components/form");
const debounce_1 = __importDefault(require("lodash/debounce"));
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let BoxesModuleForm = BoxesModuleForm_1 = class BoxesModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
        this.newItem = { text: '', heading: null, list: [] };
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = BoxesModuleForm_1.getInitialContent();
    }
    /**
     * Function to check if header exist
     */
    get hasHeader() {
        return this._content.header !== null;
    }
    /**
     * Function to set header according to hasHeader value
     */
    set hasHeader(value) {
        if (!value) {
            this._content.header = null;
            return;
        }
        this._content.header = {
            small: null,
            intro: {
                isBold: false,
                text: null
            },
            large: null
        };
    }
    created() {
        this.debouncedFunc = debounce_1.default((boxIndex, listIndex, value) => {
            this.debouncedFunc.cancel();
            const boxCopy = [...this._content.boxes];
            boxCopy[boxIndex].list[listIndex] = value;
            this._content.boxes = boxCopy;
        });
    }
    /**
     * Function to add new list item to box
     *
     * @param index of box where list item should be added
     */
    addListItem(index) {
        const boxesCopy = [...this._content.boxes];
        if (!boxesCopy[index] || !boxesCopy[index].list) {
            return;
        }
        boxesCopy[index].list.push('');
        this._content.boxes = boxesCopy;
    }
    /**
     * Function to add new box item to content
     */
    addNewItem() {
        this._content.boxes = [...this._content.boxes, { ...JSON.parse(JSON.stringify(this.newItem)) }];
    }
    /**
     * Function to delete box
     *
     * @param index of item to delete
     */
    deleteItem(index) {
        const boxesCopy = [...this._content.boxes];
        boxesCopy.splice(index, 1);
        this._content.boxes = boxesCopy;
    }
    /**
     * Function to delete box list item
     *
     * @param boxIndex index of box when item should be deleted
     * @param itemIndex index of item to delete
     */
    deleteListItem(boxIndex, itemIndex) {
        const boxesCopy = [...this._content.boxes];
        if (!boxesCopy[boxIndex] || !boxesCopy[boxIndex].list || boxesCopy[boxIndex].list.length === 0) {
            return;
        }
        boxesCopy[boxIndex].list.splice(itemIndex, 1);
        this._content.boxes = boxesCopy;
    }
    updateListElement(boxIndex, listIndex, value) {
        this.debouncedFunc(boxIndex, listIndex, value);
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Boxes,
            size: {
                colSpan: 6,
                isResizable: false,
                maxColSpan: 6,
                maxRowSpan: 1,
                minColSpan: 6,
                minRowSpan: 1,
                rowSpan: 1
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            backgroundColor: _contracts_1.ModuleBackgroundColor.None,
            background: null,
            header: null,
            boxes: []
        };
    }
};
BoxesModuleForm = BoxesModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'BoxesModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            DashmixSelect: backoffice_1.DashmixSelect,
            ModuleHeaderForm: form_2.ModuleHeaderForm,
            FormErrors: form_2.FormErrors
        },
        template: `
    <div>
      <!-- Header -->
      <DashmixCheck class="pb-2" :label="$t('forms.shared.hasHeader')" name="hasHeader"
                    :model.sync="hasHeader" />

      <ModuleHeaderForm v-if="hasHeader" :data.sync="_content.header" />
      <!-- Header| END -->

      <!-- Background -->
      <div class="form-group col-12 col-md-6">
        <label for="color">{{ $t('forms.shared.backgroundColor') }}</label>
        <DashmixSelect :model.sync="_content.backgroundColor" name="backgroundColor"
                       :placeholder="$t('forms.shared.backgroundColorPlaceholder')"
                       :options="backgroundColorOptions" :searchable="false"/>
        <DashmixInput v-if="isCustomColor" type="color" :model.sync="_content.background" name="background"/>
      </div>
      <!-- Background | END -->

      <!-- Boxes -->
      <div class="form-group mb-4">
        <label class="d-block">{{ $t('forms.boxes.elements') }}</label>

        <template v-for="(box, index) in _content.boxes">
          <div class="bg-light py-3 row mx-0 my-3">
            <div class="col-11 p-0">
              <div class="row mx-0">
                <div class="col-12 pb-3">
                  <label :for="'heading-' + index" class="d-block">{{ $t('forms.boxes.heading.label') }}</label>
                  <DashmixInput size="small" :model.sync="box.heading" :name="'heading-' + index"
                                :placeholder="$t('forms.boxes.heading.placeholder')" />
                </div>

                <div class="col-12 pb-3">
                  <label :for="'text-' + index" class="d-block">{{ $t('forms.boxes.text.label') }}</label>
                  <DashmixTextArea size="small" :model.sync="box.text" :name="'text-' + index" :rows="2"
                                   :placeholder="$t('forms.boxes.text.placeholder')" />
                </div>

                <div class="col-12">
                  <label class="d-block">{{ $t('forms.boxes.list.label') }}</label>
                  <ul>
                    <li v-for="(listItem, itemIndex) in box.list" class="mb-3" :key="'list-' + index + '-' + itemIndex">
                      <div class="row m-0">
                        <div class="col-11 p-0">
                          <DashmixInput size="small" :model="listItem" :name="'list-' + index + '-' + itemIndex"
                                        :placeholder="$t('forms.boxes.list.placeholder')"
                                        @update:model="value => updateListElement(index, itemIndex,value)"
                          />
                        </div>

                        <div class="col-1 d-flex justify-content-end align-items-center p-0">
                          <DashmixButton size="small" variant="icon" :icon="icons.TrashSolid" theme="danger"
                                         @click="() => deleteListItem(index, itemIndex)" />
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <DashmixButton :icon="icons.PlusSolid" variant="icon"
                               :label="$t('forms.boxes.list.addNew')" @click="addListItem(index)" />
              </div>
            </div>

            <div class="col-1 d-flex align-items-center p-0">
              <DashmixButton variant="icon" :icon="icons.TrashSolid" theme="danger"
                             @click="() => deleteItem(index)" />
            </div>
          </div>
        </template>

        <DashmixButton :icon="icons.PlusSolid" variant="icon"
                       :label="$t('forms.boxes.addNew')" @click="addNewItem" />
      </div>
      <!-- Boxes | END -->

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], BoxesModuleForm);
exports.BoxesModuleForm = BoxesModuleForm;
//# sourceMappingURL=Boxes.form.js.map